"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiTipConstant = exports.ApiTipConfig = exports.NoticeTemplatesConstant = exports.NoticeTypesConstant = exports.NotificationTemplates = exports.NotificationTypes = exports.Settings = exports.SystemConfig = void 0;
const api_tip_config_auto_json_1 = __importDefault(require("./api_tip_config.auto.json"));
const system_config_auto_json_1 = __importDefault(require("./system_config.auto.json"));
/**
 * config class, directly get the entire class of SystemConfig
 */
const SystemConfig = system_config_auto_json_1.default;
exports.SystemConfig = SystemConfig;
/**
 * api tip config class
 */
const ApiTipConfig = api_tip_config_auto_json_1.default;
exports.ApiTipConfig = ApiTipConfig;
/**
 * Settings object, quickly get system_config.system table, system constant configuration
 *
 * pass in key
 * @example Conf.api_rate...
 */
const Settings = SystemConfig.settings;
exports.Settings = Settings;
// notification
const jsonToObject = (object) => {
    const obj = Object.assign({}, object);
    Object.keys(object).forEach((i) => {
        obj[i] = i;
    });
    return obj;
};
const Notifications = SystemConfig.notifications;
const NotificationTypes = Notifications.types;
exports.NotificationTypes = NotificationTypes;
const NotificationTemplates = Notifications.templates;
exports.NotificationTemplates = NotificationTemplates;
const NoticeTypesConstant = jsonToObject(Notifications.types);
exports.NoticeTypesConstant = NoticeTypesConstant;
const NoticeTemplatesConstant = jsonToObject(Notifications.templates);
exports.NoticeTemplatesConstant = NoticeTemplatesConstant;
const ApiTipConstant = jsonToObject(ApiTipConfig.api.tips);
exports.ApiTipConstant = ApiTipConstant;
//# sourceMappingURL=system_config.js.map